import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../contexts/currentUserSlicer';
import { determineAppMode } from '../utils/appMode';

/**
 * Returns true if the current user (or, for unauthenticated pages, the current hostname)
 * indicates a B2B context.
 */
export function useIsB2B(): boolean {
  const currentUser = useSelector(selectCurrentUser);
  if (currentUser) {
    return currentUser.category === 'B2B-SMB';
  }
  return determineAppMode() === 'b2b';
}
